module.exports = __webpack_public_path__ + "static/media/mobile-contact.7afef7fc.png";